import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useWoody } from '../../woody/woody.js';
import { publishQueryKeys } from '../queries/publishQueryKeys.js';
import { toast } from '../../store/alerts.js';

const useMutationPublishUpdate = () => {
  const { client } = useWoody();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async ({ resourceId, publishDetails }) => {
      return client.v2({
        endpoint: "/v2/resources/{resourceId}/publish",
        params: {
          resourceId
        }
      }, {
        method: "patch",
        body: publishDetails
      });
    },
    onMutate: ({ resourceId, publishDetails }) => {
      queryClient.setQueryData(publishQueryKeys.resourcePublishDetails(resourceId), (oldData) => {
        if (!oldData) {
          return void 0;
        }
        return {
          ...oldData,
          ...publishDetails
        };
      });
    },
    onSuccess: (data, { resourceId }) => {
      queryClient.setQueryData(publishQueryKeys.resourcePublishDetails(resourceId), data);
      toast({
        content: "Publishing settings updated",
        id: "publish-update-success"
      });
    },
    onError: (error, { resourceId }) => {
      toast({
        content: "Failed to update publish details",
        id: "publish-update-error"
      });
      queryClient.invalidateQueries({
        queryKey: publishQueryKeys.resourcePublishDetails(resourceId)
      });
    }
  });
  return mutation;
};

export { useMutationPublishUpdate };
//# sourceMappingURL=useMutationPublishUpdate.js.map
